exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@font-face {\n  font-family: 'MinionPro-Regular';\n  src: url(" + require("./MinionPro-Regular.eot") + "?#iefix) format('embedded-opentype'),  url(" + require("./MinionPro-Regular.otf") + ")  format('opentype'),\n\t     url(" + require("./MinionPro-Regular.woff") + ") format('woff'), url(" + require("./MinionPro-Regular.ttf") + ")  format('truetype'), url(" + require("./MinionPro-Regular.svg") + "#MinionPro-Regular) format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/opt/buildhome/repo/node_modules/postcss-loader?{"ident":"postcss"}!/opt/buildhome/repo/src/assets/fonts/MinionPro-Regular/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/fonts/MinionPro-Regular/styles.css
// module chunks = styles